module.exports = __webpack_public_path__ + "img/puzzle-fill.5e6d8ece.svg";